import { memo, useCallback } from 'react';

import CustomCheckbox from '@/components/Checkbox';
import type { SymbolKey } from '@/entities/symbol';
import { isSameSymbol, isSameSymbolIgnoringPeriod } from '@/entities/symbol';
import useSelectionFunctions from '@/features/SymbolSelector/hooks/useSelectionFunctions';
import { useAppSelector } from '@/hooks/redux-hooks';

const SymbolCheckboxComponent = ({
  symbol,
  disabled
}: {
  symbol: SymbolKey;
  disabled?: boolean;
}) => {
  const { isSpotLocked, toggleSymbolInSelection } = useSelectionFunctions();

  const isChecked = useAppSelector(state => {
    const equals = isSpotLocked ? isSameSymbolIgnoringPeriod : isSameSymbol;
    return state.symbolSelector.symbols.some(s => equals(s, symbol));
  });

  const handleChange = useCallback(() => {
    toggleSymbolInSelection(symbol);
  }, [toggleSymbolInSelection, symbol]);

  return (
    <CustomCheckbox
      checked={isChecked}
      disabled={disabled}
      modeLocked={isSpotLocked}
      onLockedClick={handleChange}
      onChange={handleChange}
    />
  );
};

export const SymbolCheckbox = memo(SymbolCheckboxComponent);
